import React, { useEffect, useState } from 'react';

import {
  SearchComponent,
  ISearchComponent,
} from '../../core/components/SearchComponent';

import lineModules from '../../core/components/lineModules'
import { Container, TicketCard } from './styles';
import { useParams } from 'react-router-dom';
import { AplicarCortesia } from './modules/AplicarCortesia';
import { useAuth } from '../../../../hooks/Auth';
import { useConfiguration } from '../../../../hooks/Configuration';
import contactModule from './modules/ContactModule';
import visualizarCodigo from './modules/VisualizarCodigo';
import updateStudents from './modules/updateStudents';
import api from 'src/services/api';
import { Form } from '@unform/web';

import RichText from './Components/RichText';
import { useModal } from 'src/hooks/Modal';

import { useToast } from 'src/hooks/Toast';
import { useLoading } from 'src/hooks/LoadingHook';
import { uuid } from 'uuidv4';
import OpenTicket from './Components/OpenTicket';
import CheckboxInput from './Components/CheckboxInput';
import ImageMultiGalleryInputToStatic from './Components/ImageMultiGalleryInputToStatic';
import { MdChat } from 'react-icons/md';
import { FaChevronCircleLeft, FaClock, FaQuestionCircle, FaUser } from 'react-icons/fa';
import { dateSimpleBRWithHour } from 'src/utils/date';
import Input from './Components/Input';
import SelectSimple from './Components/SelectSimple';
interface ValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface ValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<ValidationRules>;
}

interface ILine {
  [key: string]: string;
}
interface IParams {
  projectHash: string;
  eventHash: string;
}


interface IProps {
  search?: string;
  category?: string;
  status?: string;
  reload?: string;
  openMessage: Function;
}

const useTicketsComunication = () => {

  const [ticketsList, setTicketsList] = useState([]);
  const [ticketsCount, setTicketsCount] = useState(0);

  const searchTickets = async ({ search, category, status }) => {

    const where: Record<string, any> = { status };

    if (category) {
      where.category = category;
    }

    const list = await api.get('/tickets-comunication', { params: { search, where: where } })

    setTicketsList(list?.data?.rows);
    setTicketsCount(list?.data?.count);
  }

  return { searchTickets, ticketsList, ticketsCount }
}


const useTicketsComunicationStatus = () => {
  const { addModal } = useModal();
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('');
  const [active, setActive] = useState(true);
  const [reload, setReload] = useState('');



  const [categories, setCategories] = useState([
    "Ensino",
    "Eventos",
    "Financeiro",
    "Plataforma"
  ])


  /*
    const categoriesList = categories?.reduce((prev: Array<Record<string, any>>, item) => {
  
      prev.push({ label: item, value: item })
  
      return prev;
    }, [])
  
    */

  const categoriesList = [
    { label: "Acesso e Login", value: "Acesso e Login" },
    { label: "Certificados", value: "Certificados" },
    { label: "Configurações de Plataforma", value: "Configurações de Plataforma" },
    { label: "Estorno", value: "Estorno" },
    { label: "Financeiro", value: "Financeiro" },
    { label: "Novos Recursos", value: "Novos Recursos" },
    { label: "Evento", value: "Evento" },
    { label: "Orçamento", value: "Orçamento" },
    { label: "Pagamentos", value: "Pagamentos" },
    { label: "Satisfação e Sugestões", value: "Satisfação e Sugestões" },
    { label: "Transmissão ao Vivo", value: "Transmissão ao Vivo" },
    { label: "Outros", value: "Outros" },
  ]



  return { search, category, setCategory, setSearch, categoriesList, setReload, reload, active, setActive }
}
const getPriorityColor = (priority) => {
  switch (priority) {
    case 'Crítica': return '#dc3545';
    case 'Alta': return '#fd7e14';
    case 'Média': return '#ffc107';
    case 'Baixa': return '#28a745';
    default: return '#6c757d';
  }
};

const RenderMessage = ({ item, openMessage }) => {
  const priorityColor = getPriorityColor(item.priority);

  return (
    <TicketCard onClick={() => openMessage(item)} className='scaleOnHover gap-xs column-start' style={{ cursor: 'pointer', borderLeft: `5px solid ${priorityColor}` }}>
      <small className='row-start' style={{ gap: '15px', marginBottom: '5px', color: '#888' }}>
        <FaClock style={{ fontSize: '14px', color: '#162743' }} />
        {item.createdAt ? dateSimpleBRWithHour(item.createdAt) : 'Data não informada'}
        <FaUser style={{ fontSize: '14px', color: '#162743', marginLeft: '10px' }} />
        {item.client_name}
      </small>
      <h4 style={{ fontSize: '16px' }} >

        {item.title}</h4>
      <p style={{ maxHeight: '54px', width: '100%', height: 'auto', overflow: 'hidden' }} dangerouslySetInnerHTML={{ __html: item.description }} />


      <p className="meta">
        <strong> Categoria:</strong> {item.category} |
        <strong> Prioridade:</strong> <span style={{ color: priorityColor }}>{item.priority}</span>
      </p>
    </TicketCard>
  );
};


const ShowList: React.FC<IProps> = ({ openMessage, search, category, status, reload }) => {

  const { searchTickets, ticketsList, ticketsCount } = useTicketsComunication()

  useEffect(() => {
    searchTickets({ status, search, category })
  }, [status, search, category, reload])

  return <div className='column max-400 pad-sm' style={{ maxWidth: '300px', width: '100%', background: '#efefef' }}>
    <h2 className='row-start gap-xs' style={{ color: '#162743', padding: '10px', width: '100%', textAlign: 'left' }}>
      <div className='row' style={{ background: '#162743', color: '#fff', fontSize: '12px', width: '20px', height: '20px', borderRadius: '50%' }}>{ticketsCount}</div>

      {status}</h2>
    {ticketsList?.map(item => {

      return <RenderMessage openMessage={openMessage} item={item} />

    })}

  </div>

}

const CreateTicket = ({ categories, reloadItems, returnToDashboard }) => {
  const { addToast } = useToast();
  const { addLoading, removeLoading } = useLoading();
  const { addModal, removeModal } = useModal();
  const createTicketItem = async (data) => {


    data.priority = data?.priority?.[0] || '';


    if (!data?.title) {
      addToast({ title: 'Preencha o título', type: 'error' });
      return;
    }
    if (!data?.description) {
      addToast({ title: 'Preencha o descritivo', type: 'error' });
      return;
    }
    if (!data?.category) {
      addToast({ title: 'Selecione uma categoria', type: 'error' });
      return;
    }
    if (!data?.priority) {
      addToast({ title: 'Informe o nível de prioridade', type: 'error' });
      return;
    }

    addLoading({ title: 'Carregando', key: 'loading' })
    try {

      await api.post('/create-ticket-comunication', data);
      removeLoading('loading');
      addToast({ title: 'Ticket criado com sucesso', type: 'success' });
      removeModal('modal');
      reloadItems();
      window?.scrollTo(0, 0);
    }
    catch (err) {
      addToast(err?.response?.data?.error || err?.response?.data?.message || 'Erro ao criar ticket')
      removeLoading('loading');

    }

  }

  return <>

    <div className='row' style={{ width: '100%', padding: '15px 30px', background: '#ddd', justifyContent: 'center' }}>
      <button onClick={() => { returnToDashboard(); }}
        style={{ background: '#162743', color: '#fff' }} className='button cursor gap-sm row scaleOnHover'><FaChevronCircleLeft style={{ fontSize: '18px', cursor: 'pointer' }} title="Voltar" />      <h2 style={{ color: '#fff' }}>Voltar</h2>  </button>
      <div className='row-to-column' style={{ padding: '10px', width: '100%', justifyContent: 'space-between' }}>
        <h2 style={{ color: '#333' }}>Criar chamado</h2>

      </div>
    </div>




    <Form className='full-width' onSubmit={createTicketItem} initialData={{ priority: 'Baixa' }}>

      <div className='row-to-column gap' style={{ alignItems: 'flex-start', paddingTop: '15px' }}>

        <div className='column-start full-width gap-sm' style={{ padding: '30px', background: '#fff' }}>

          <p style={{ color: '#333', padding: '10px', fontWeight: 'bold', textAlign: 'left', width: '100%' }}>Assunto:</p>

          <Input name='title' placeholder='' />
          <p style={{ color: '#333', padding: '10px', fontWeight: 'bold', textAlign: 'left', width: '100%' }}>Descreva o motivo do chamado:</p>
          <RichText placeholder='' name='description' />

          <ImageMultiGalleryInputToStatic placeholder='Anexos' list={[{ name: 'url', title: 'Imagem' }]} name='uploads' />

        </div>
        <div className='column  max-500' style={{ gap: '15px', width: '100%' }}>
          <div className='column  full-width' style={{ padding: '30px', background: '#fff' }}>
            <CheckboxInput unique name="priority" preText={<div className='row-start gap-xs'>
              <h2>Prioridade</h2>

              <FaQuestionCircle onClick={() => {

                addModal({
                  title: '', theme: 'whiteModal', content: <>
                    <h2>Como funcionam as prioridades:</h2>
                    <table className='tableRef'>
                      <thead>
                        <tr>
                          <th>Prioridade</th>
                          <th>Descrição</th>
                          <th>Tempo Sugerido de Resposta</th>
                          <th>Exemplo de Situação</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Baixa</td>
                          <td>Chamado que pode ser tratado sem urgência. Não afeta o funcionamento do sistema.</td>
                          <td>4 a 7 dias úteis</td>
                          <td>Sugestão de melhoria estética, solicitação de novos recursos na plataforma, dúvida genérica</td>
                        </tr>
                        <tr>
                          <td>Normal</td>
                          <td>Chamado importante, mas que não impede o uso da plataforma.</td>
                          <td>2 a 4 dias úteis</td>
                          <td>Pedido de atualização cadastral, estornos, criação de novos projetos, relatórios, correção de layout</td>
                        </tr>
                        <tr>
                          <td>Média</td>
                          <td>Chamado que impacta parcialmente o funcionamento, mas há alternativas.</td>
                          <td>48 horas úteis</td>
                          <td>Alteração de campos de inscrição em evento em andamento, alteração de prazos,  dificuldade de acesso em alguns navegadores</td>
                        </tr>
                        <tr>
                          <td>Alta</td>
                          <td>Chamado que impacta diretamente o uso normal da plataforma, mas o sistema ainda está ativo.</td>
                          <td>6 a 8 horas úteis</td>
                          <td>Inscrições ou pagamentos prejudicados, impossibilidade de acesso aos conteúdos on demand</td>
                        </tr>
                        <tr>
                          <td>Crítica</td>
                          <td>Chamado de emergência: sistema fora do ar, evento bloqueado, falha geral.</td>
                          <td>Imediato (até 4 horas)</td>
                          <td>Plataforma indisponível, vendas impossibilitadas, falha em live no ar</td>
                        </tr>
                      </tbody>
                    </table>
                  </>
                })

              }} title='Entenda os prazos' style={{ fontSize: '18px', color: '#333', cursor: 'pointer' }} /></div>} placeholder='Prioridade' options={[
                { label: 'Baixa: sugestões ou dúvidas', value: 'Baixa' },
                { label: 'Normal: ajustes', value: 'Normal' },
                { label: 'Média: impacto parcial', value: 'Média' },
                { label: 'Alta: problema grave', value: 'Alta' },
                { label: 'Crítica: sistema fora do ar', value: 'Crítica' },
              ]} />
          </div>
          <div className='column   full-width gap-xs' style={{ padding: '30px', background: '#fff' }} >
            <div className='row-start'> <h2>Categoria do chamado:</h2></div>

            <SelectSimple index={10} name="category" label={""} options={categories} />
          </div>
          <div className='column    full-width' style={{ padding: '30px', background: '#fff' }} >
            <button style={{ margin: '10px 0px' }} className='greenButton2 button'>Criar ticket</button>
          </div>
        </div>
      </div>


    </Form>
  </>

}


const TicketComunication: React.FC = () => {

  const { user } = useAuth();
  const { addModal } = useModal();
  const { configuration } = useConfiguration();


  const [currentTicket, setCurrentTicket] = useState<Record<string, any>>({})
  const { search, setSearch, category, setCategory, categoriesList, setReload, reload, active, setActive } = useTicketsComunicationStatus();

  const createTicket = () => {

    setCurrentTicket({});
    setActive(false);

  }

  const openMessage = (item) => {

    setCurrentTicket(item);
    setActive(false);

  }

  return (
    <Container>

      <div className='row-to-column gap-xs' style={{ display: active ? 'flex' : 'none', background: '#ddd', padding: '15px', justifyContent: 'space-between' }}>
        <div className='row-to-column gap-xs' style={{ width: '500px', gap: '10px', maxWidth: '100%' }}>
          <button className='greenButton2 button' style={{ minWidth: '200px' }} onClick={() => createTicket()} ><MdChat style={{ fontSize: '18px' }} /> Criar chamado</button>

          <select name='category' style={{ minWidth: '250px' }} onChange={(e) => setCategory(e?.target?.value || '')}>
            <option value={""} selected={category === ''}>Filtrar</option>
            {categoriesList?.map((categoryItem) => {
              return <option value={categoryItem?.label} selected={category === categoryItem?.label}>{categoryItem?.label}</option>

            })}

          </select>
        </div>

        <div className='row gap-xs' style={{ width: '400px', gap: '10px', maxWidth: '100%' }}>
          <Form style={{ gap: '10px' }} className='row' onSubmit={(data) => setSearch(data?.search)}>
            <Input name='search' placeholder='' />
            <button className='button'  >Pesquisar</button>
          </Form>
        </div>
      </div>

      <div className='row-to-column gap-sm' style={{ display: active ? 'flex' : 'none', alignItems: 'flex-start' }}>

        <ShowList status='Aguardando' search={search} category={category} reload={reload} openMessage={(message) => openMessage(message)} />
        <ShowList status='Em análise' search={search} category={category} reload={reload} openMessage={(message) => openMessage(message)} />
        <ShowList status='Em produção' search={search} category={category} reload={reload} openMessage={(message) => openMessage(message)} />
        <ShowList status='Encerrado' search={search} category={category} reload={reload} openMessage={(message) => openMessage(message)} />
      </div>

      {!active && currentTicket?._id ? <OpenTicket returnToDashboard={() => { setActive(true); window?.scrollTo(0, 0); }} item={currentTicket} reloadItems={() => setReload(uuid())} /> : <></>}
      {!active && !currentTicket?._id ? <CreateTicket returnToDashboard={() => { setActive(true); window?.scrollTo(0, 0); }} categories={categoriesList} reloadItems={() => { setReload(uuid()); setActive(true) }} /> : <></>}


    </Container>
  );
};

export default TicketComunication;
